import styled from 'styled-components';

import { LabelS } from 'atoms/typography';

import { useIntlContext } from '..';

type Props = {
  date: Date;
};

const Root = styled(LabelS)`
  white-space: nowrap;
`;

export const Since = ({ date }: Props) => {
  const { formatDistanceToNow } = useIntlContext();

  return <Root color="var(--c-nd-600)">{formatDistanceToNow(date)}</Root>;
};
